import { IDefectSource } from '@/models/IDefectNotice';
import { Api } from '@/plugins/api';
import { Toast } from '@/plugins/toast';
import { EventBus, Event } from '@/plugins/bus';

export const DefectSourcesStore = {
    data: {
        sources: null as IDefectSource[] | null
    },
    methods: {
        updateList(data: []) {
            DefectSourcesStore.data.sources = data;
            EventBus.$emit(Event.DefectSourcesUpdated, data);
        },

        async getData() {
            try {
                if (DefectSourcesStore.data.sources != null) {
                    return DefectSourcesStore.data.sources;
                }
                const response = await Api.get(`defect-sources`);
                DefectSourcesStore.methods.updateList(response.data);
                return response.data;
            } catch (error) {
                Toast.error('There was an error getting defect sources');
                return null;
            }
        }
    }
};
